module.exports = __webpack_public_path__ + "static/human_monk_male_SCAG-03b003b87d7464cd28fd290a04057c84.png";